import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from './components/ui/button/button.component';
import { InputComponent } from './components/ui/input/input.component';
import { ModalComponent } from './components/ui/modal/modal.component';
import { AlertComponent } from './components/ui/alert/alert.component';
import { CustomAudioPlayerComponent } from './components/ui/custom-audio-player/custom-audio-player.component';
// Vive en shared porque lo usan dos sitios: la página de Llamadas y la pestaña
// de Llamadas del panel del chat. Un componente no puede declararse dos veces.
import { CallPlayerComponent } from './components/call-player/call-player.component';
import { UserPickerComponent } from './components/ui/user-picker/user-picker.component';
import { HasPermissionDirective } from './directives/has-permission.directive';
import {
  LucideAngularModule, User, Lock, Unlock, Mail, ChevronRight, MessageSquare, Users, Settings, LogOut,
  CheckCircle, XCircle, AlertTriangle, Info, Plus, Menu, Loader2, Phone, Edit2, Edit, Trash2, UsersRound,
  Search, MessageCircle, Tag, Clock, ChevronLeft, Inbox, X, Eye, EyeOff, Paperclip, Smile, Mic, MicOff,
  Send, MoreVertical, Image, FileText, Check, CheckCircle2, ArrowLeft, ArrowRight, ArrowUp, Play, Pause, Film,
  UserX, CalendarClock, Save, Building2, Globe, DollarSign, CheckSquare, Calendar, CalendarX,
  PlusCircle, UserCheck, FileX, UserPlus, UploadCloud, RefreshCw, ClipboardList, Tags,
  Contact, UserCog, Smartphone, List, Building, ShieldAlert, ShieldCheck, Sliders, Infinity,
  Settings2, ToggleRight, ToggleLeft, Ban, Database, SearchX, UserMinus,
  MapPin, ImageOff, ExternalLink, Contact2, Pointer, PhoneMissed, PhoneOff, ArrowDown, LocateFixed, Zap, ZoomIn,
  AlertCircle, Megaphone, Link, LogIn, Link2Off, ChevronDown, Copy, Download, BarChart2, Filter, TrendingUp,
  TrendingDown, PieChart, Grid, Coffee, Utensils, Bot, RotateCw, RotateCcw, Square,
  ChevronUp, ArrowDownLeft, ArrowUpRight, Sparkles
} from 'lucide-angular';

const ICONS = {
  User, Lock, Unlock, Mail, ChevronRight, MessageSquare, Users, Settings, LogOut, CheckCircle, CheckCircle2,
  XCircle, AlertTriangle, Info, Plus, Menu, Loader2, Phone, Edit2, Edit, Trash2, UsersRound, Search,
  MessageCircle, Tag, Tags, Clock, ChevronLeft, ArrowLeft, Inbox, X, Eye, EyeOff, Paperclip, Smile, Mic, MicOff,
  Send, MoreVertical, Image, FileText, Check, ArrowRight, ArrowUp, Play, Pause, Film,
  UserX, CalendarClock, Save, Building2, Globe, DollarSign, CheckSquare, Calendar, CalendarX,
  PlusCircle, UserCheck, FileX, UserPlus, UploadCloud, RefreshCw, ClipboardList,
  Contact, UserCog, Smartphone, List, Building, ShieldAlert, ShieldCheck, Sliders, Infinity,
  Settings2, ToggleRight, ToggleLeft, Ban, Database, SearchX, UserMinus,
  MapPin, ImageOff, ExternalLink, Contact2, Pointer, PhoneMissed, PhoneOff, ArrowDown, LocateFixed, Zap,
  ZoomIn, AlertCircle, Megaphone, Link, LogIn, Link2Off, ChevronDown, Copy, Download, BarChart2, Filter,
  TrendingUp, TrendingDown, PieChart, Grid, Coffee, Utensils, Bot, RotateCw, RotateCcw, Square,
  ChevronUp, ArrowDownLeft, ArrowUpRight, Sparkles
};

@NgModule({
  declarations: [
    ButtonComponent,
    InputComponent,
    ModalComponent,
    AlertComponent,
    CustomAudioPlayerComponent,
    CallPlayerComponent,
    UserPickerComponent,
    HasPermissionDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    LucideAngularModule.pick(ICONS)
  ],
  exports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    LucideAngularModule,
    ButtonComponent,
    InputComponent,
    ModalComponent,
    AlertComponent,
    CustomAudioPlayerComponent,
    CallPlayerComponent,
    UserPickerComponent,
    HasPermissionDirective
  ]
})
export class SharedModule { }
